import { IStateDispatchActions } from '../RouteInfo.context';

interface ISetClubIdAugmentedArgs {
  clubId: string | undefined;
}

export type ISetClubId = (args: ISetClubIdAugmentedArgs) => void;

export const setClubId: IStateDispatchActions<ISetClubId> = (_, dispatch) => args => {
  const { clubId } = args;

  dispatch({ type: 'setClubId', value: clubId });
};
